import styled, { css } from 'styled-components'
import { withBox } from '../Box'
import { InputHTMLAttributes } from 'react'

export interface TextAreaProps
  extends InputHTMLAttributes<HTMLTextAreaElement> {
  $resize?: 'none' | 'vertical' | 'horizontal' | 'both'
  $minHeight?: string
  $maxHeight?: string
  disabled?: boolean
  invalid?: boolean
}

export const TextArea = styled(withBox('textarea'))<TextAreaProps>`
  display: block;
  position: relative;
  padding: 10px;
  width: 100%;
  line-height: 1.5;
  appearance: none;

  ${({ theme, $resize, $minHeight, $maxHeight, disabled, invalid }) => css`
    background-color: ${theme.colors.background.tertiary.C};
    color: ${theme.colors.foreground.secondary.A};
    font-size: ${theme.fontSizes.E};
    resize: ${$resize};
    min-height: ${$minHeight};
    max-height: ${$maxHeight};
    transition:
      border-color ${theme.transitions.duration[1]}
        ${theme.transitions.timing.easeInOut},
      padding ${theme.transitions.duration[4]}
        ${theme.transitions.timing.easeOutExponential};

    ::placeholder {
      color: ${theme.colors.foreground.secondary.D};
      opacity: 1; /* Override Firefox default */
    }

    ::selection {
      background-color: ${invalid
        ? theme.colors.state.negative.E
        : theme.colors.sketch.E};
    }

    /* This avoids a small jump when focusing / unfocusing the input due to the border increasing the input size*/
    border: 2px solid transparent;
    border-radius: 6px;
    outline-offset: unset;

    /* Add the disabled look and feel to the stripe inputs */
    ${disabled &&
    css`
      color: ${theme.colors.foreground.secondary.D};
      background-color: ${theme.colors.background.secondary.B};

      border: 1px dashed ${theme.colors.border.A};
    `};

    ${invalid &&
    css`
      border: 2px solid ${theme.colors.state.negative.A};
    `};
  `};
`
